<template>
  <div>
      <h5 style="border-bottom:1px solid #ccc;">Figure {{ numIndex}}: {{ title }}</h5>
      <figure>
        <figcaption>{{ label }}</figcaption>
        <div class="image-wrapper"><img v-bind:src="imageUrl" style="width:100%"></div>
        <div class="attribution">{{attribution}}</div>
      </figure> 
      
  </div>
</template>

<script>
/* eslint-disable */

import _ from 'lodash'; 

export default {
    name: 'Figure',
    components: { },
    props: ['location', 'source', 'download', 'title', 'description', 'layout', 'attribution', 'factsheet', 'loaded', 'label', 'sublabel', 'src', 'num'],
    data() {
      return {
        numIndex: this.num ? this.num : 'X'
      }
    },
    mounted() {
    },
    watch: {
      location() {
      },
      background() {
      },
      loaded() {
      }
    },
    methods: {
      urlForImage(image) {
        return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+image.source;
      }
    },
    computed: {
      imageUrl() {
        if(this.loaded) {
          return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/'+this.src;
        }
      },
      downloadUrl() {
        if(this.loaded) {
          return process.env.VUE_APP_API+'/api/data/factsheet/'+this.factsheet.info.identifier+'/data/gadm_summary/gadm_level1.geojson';
        }
      }
    }
}
</script>
<style>
</style>

<style scoped>

h4 {
  margin:0px;
  padding:8px;
  padding-left:10px;
  font-size:0.9em;
  width:100%;
  color:#444;
}
h5 {
  font-size:0.7em;
  color:rgb(33, 37, 41);
  font-weight:600;
  padding:12px 0px 8px 0px;
  margin:0px;

}
figcaption {
  font-size:0.75em;
  color:rgb(33, 37, 41);
  padding:8px 8px 8px 8px;
  border-bottom:1px dashed #ccc;
}
figure {
  background-color:#f5f5f5;
  //border: 1px solid #ddd;
}
div.image-wrapper {
  padding:8px;
}
div.attribution {
  font-size:0.55em;
  color:#666;
  padding:4px 8px 4px 8px;
}
p {
  margin:0px;
  font-size:0.6em;
  color:#222;
}
p.attribution {
  font-size:0.5em;
  padding:0px 6px 3px 6px;
  color:#888;
}
div.cmd, div.row {
  
}
div.map-wrap {
 background-color:#f5f5f5; 
 border-top:1px solid #ddd;
 border-bottom:1px solid #ddd;
}
a.btn-command:focus, a.btn-command:active {
  outline:none !important;
  box-shadow:none;
} 
a.btn-command {
  background-color:#f5f5f5;
  color:#999;
}
a.btn-command:hover {
  background-color:#eeeeee;
  color:#777;
}
a.btn-command i {
  font-size:0.8em;
}
div.legend-wrapper {
  padding:7px;
}
div.layer-commands {
  margin-top:3px;
  font-size:1em;
}
div.layer-commands a.btn-layer {
  color:#aaa;
}
div.layer-commands a.btn-layer:hover {
  color:#0056b3;
}
.btn:focus,.btn:active {
   outline: none !important;
   box-shadow: none;
}
</style>